module.exports = __webpack_public_path__ + "img/arrow.b2bfa46e.svg";